/*!
 * MerchantFlow — Koleksiyon "Daha fazla yükle" + "Infinite scroll"
 * Sayfalama modu Liquid'de belirlenir (data-pagination-mode). Bu script
 * sadece `load_more` veya `infinite` modda çalışır.
 *
 * Nasıl çalışır:
 *   1) data-next-url'den bir sonraki sayfayı fetch et
 *   2) Response HTML'ini parse et, #product-grid içindeki <li> item'ları al
 *   3) Mevcut grid'in sonuna append
 *   4) Yeni next-url'i güncelle (yoksa mekanizmayı kapat)
 */
(function () {
  'use strict';

  const GRID_SELECTOR = '#product-grid';
  const initedSet = new WeakSet();

  async function loadNext(button, nextUrl, statusEl) {
    if (!nextUrl || button.dataset.mfLoading === '1') return;
    button.dataset.mfLoading = '1';
    button.disabled = true;
    if (statusEl) statusEl.style.display = 'flex';

    try {
      const res = await fetch(nextUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newGrid = doc.querySelector(GRID_SELECTOR);
      const oldGrid = document.querySelector(GRID_SELECTOR);
      if (!newGrid || !oldGrid) throw new Error('Grid bulunamadı');

      // Yeni item'ları al ve mevcut grid'e ekle
      const items = newGrid.querySelectorAll(':scope > li');
      const frag = document.createDocumentFragment();
      items.forEach((li) => frag.appendChild(li));
      oldGrid.appendChild(frag);

      // Yeni next-url'i çek — response'daki load-more butonundan veya sentinel'den
      const nextBtn = doc.querySelector('[data-mf-load-more]');
      const nextSentinel = doc.querySelector('[data-mf-infinite]');
      const newNext =
        (nextBtn && nextBtn.dataset.nextUrl) ||
        (nextSentinel && nextSentinel.dataset.nextUrl) ||
        null;

      if (newNext) {
        button.dataset.nextUrl = newNext;
      } else {
        // Son sayfa — button/sentinel'i tamamen kaldır
        const wrap = button.closest('.mf-load-more-wrap');
        if (wrap) wrap.remove();
        else button.remove();
      }
    } catch (e) {
      console.error('[mf-collection-paging]', e);
      button.textContent = 'Yeniden dene';
    } finally {
      button.dataset.mfLoading = '0';
      button.disabled = false;
      if (statusEl) statusEl.style.display = 'none';
    }
  }

  function initLoadMore() {
    const btn = document.querySelector('[data-mf-load-more]');
    if (!btn || initedSet.has(btn)) return;
    initedSet.add(btn);
    btn.addEventListener('click', () => {
      loadNext(btn, btn.dataset.nextUrl, null);
    });
  }

  async function loadInfinitePage(sentinel, statusEl) {
    const nextUrl = sentinel.dataset.nextUrl;
    if (!nextUrl || sentinel.dataset.mfLoading === '1') return;
    sentinel.dataset.mfLoading = '1';
    if (statusEl) statusEl.style.display = 'flex';
    try {
      const r = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!r.ok) throw new Error('HTTP ' + r.status);
      const html = await r.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newGrid = doc.querySelector(GRID_SELECTOR);
      const oldGrid = document.querySelector(GRID_SELECTOR);
      if (!newGrid || !oldGrid) throw new Error('Grid yok');
      const items = newGrid.querySelectorAll(':scope > li');
      const frag = document.createDocumentFragment();
      items.forEach((li) => frag.appendChild(li));
      oldGrid.appendChild(frag);
      const newSentinel = doc.querySelector('[data-mf-infinite]');
      if (newSentinel && newSentinel.dataset.nextUrl) {
        sentinel.dataset.nextUrl = newSentinel.dataset.nextUrl;
      } else {
        sentinel.remove();
      }
    } catch (e) {
      console.error('[mf-collection-paging infinite]', e);
    } finally {
      sentinel.dataset.mfLoading = '0';
      if (statusEl) statusEl.style.display = 'none';
    }
  }

  function initInfinite() {
    const sentinel = document.querySelector('[data-mf-infinite]');
    if (!sentinel || initedSet.has(sentinel)) return;
    initedSet.add(sentinel);
    const statusEl = document.querySelector('.mf-infinite-status');

    // 1) IntersectionObserver (primary)
    let io = null;
    try {
      io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              loadInfinitePage(sentinel, statusEl).then(() => {
                if (!document.body.contains(sentinel) && io) io.disconnect();
              });
            }
          });
        },
        { rootMargin: '600px 0px', threshold: 0.01 },
      );
      io.observe(sentinel);
    } catch (e) {
      console.warn('[mf-collection-paging] IO not available', e);
    }

    // 2) Scroll event fallback (Dawn body:grid layout'unda IO tetiklenmiyor)
    const onScroll = () => {
      if (!document.body.contains(sentinel)) {
        window.removeEventListener('scroll', onScroll);
        return;
      }
      const rect = sentinel.getBoundingClientRect();
      // Sentinel viewport altında en fazla 800px varsa fetch başlat
      if (rect.top <= window.innerHeight + 800 && rect.top >= -window.innerHeight) {
        loadInfinitePage(sentinel, statusEl);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    // İlk yüklemede kontrol et (kısa sayfa senaryosu)
    setTimeout(onScroll, 300);
  }

  function initAll() {
    initLoadMore();
    initInfinite();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor: section her re-render'da tekrar init et
  document.addEventListener('shopify:section:load', (e) => {
    if (!e || !e.target || e.target.querySelector('#product-grid, [data-mf-infinite], [data-mf-load-more]')) {
      initAll();
    }
  });

  // Safety net: preview iframe'de bazen DOMContentLoaded geç geliyor
  setTimeout(initAll, 500);
  setTimeout(initAll, 1500);
})();
